import styled from "styled-components"

const ToggleContainer = styled.button<{ lightTheme: boolean }>`
    background: ${({ theme }) => theme.gradient};
    border: 2px solid ${({ theme }) => theme.toggleBorder};
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    padding: 5px;
    height: 90%;
    width: 55px;
    outline: none;
    position: relative;

    &:focus {
        outline: none;
    }

    img {
        outline: none;
        transition: all 0.3s linear;
        height: 100%;
        width: 100%;

        // sun icon
        &:first-child {
            transform: ${({ lightTheme }) => (lightTheme ? "translateY(0)" : "translateY(160%)")};
        }

        // moon icon
        &:nth-child(2) {
            transform: ${({ lightTheme }) => (lightTheme ? "translateY(160%)" : "translateY(-100%)")};
        }
    }
`

export default ToggleContainer
